module.exports = __webpack_public_path__ + "img/6-6.6afaca60.jpeg";